import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  siteDetails: any = {};
  cmsList: any = {};
  usrmail = false;
  subscribeObj: any = {}

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute) { }

  ngOnInit() {
    this.getSettings();
    this.getCms();
  }
  
  getSettings() {
    this.conn.getUrl('admin/settings').subscribe((res: any) => {
      if (res.status == true) {
        this.siteDetails = res.data
      }
    })
  }

  getCms() {
    this.conn.getUrl('cms/find_cms').subscribe((res: any) => {
      if (res.status == true) {
        this.cmsList = res.data
      }
    })
  }

  subscribeAdd(subscribe: NgForm) {
    if (this.subscribeObj.email != undefined ) {
      if (subscribe.valid) {
        this.conn.postUrl('users/subscribe', { email: this.subscribeObj.email })
        .subscribe((res: any) => {
          if (res.status == true) {
            this.alert.success(res.msg);
            subscribe.reset()
          }
          else {
            this.alert.error(res.msg);
          }
        })
      }
      else {
        this.alert.error('Enter valid email');
      }
    }
    else {
      this.alert.error('Fill the required field');
    }
  }

  removeSpace(event: any) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }
}
